import AnimationIcon from '@mui/icons-material/Animation';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import {User} from '@cp/model';
import GeneralSettingsAnimation from './GeneralSettingsAnimation';
import GeneralSettingsBackground from './GeneralSettingsBackground';
import GeneralSettingsSound from './GeneralSettingsSound';

export interface GeneralSettingsCardProps {
  user?: User | null;
}

export default function GeneralSettingsCard({user}: GeneralSettingsCardProps) {
  return (
    <Paper sx={{p: 6, mb: 3}}>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 2, mb: 3}}>
        <AnimationIcon color="primary" />
        <Typography variant="h6">General Settings</Typography>
      </Box>

      <GeneralSettingsAnimation user={user} />
      <Divider sx={{my: 2}} />

      <GeneralSettingsBackground user={user} />
      <Divider sx={{my: 2}} />

      <GeneralSettingsSound user={user} />
    </Paper>
  );
}
